import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { isEmpty } from 'lodash'
import { getSubmission } from './api'
import NotHaveAccess from '../components/shared/NotHaveAccess'

const withSubmission = (WrappedComponent) => {
  return (props) => {
    const { id: submissionId } = useParams()
    const user = useSelector((state) => state.user)
    const reduxSubmission = useSelector((state) => state.app.submission)

    const [state, setState] = useState({
      submission: undefined,
      isAuthorized: true,
    })

    useEffect(() => {
      if (submissionId) {
        getSubmission(user, { id: submissionId })
          .then((response) => {
            if (response.status === 200) {
              let formBuildSubmission = { ...response.data }

              if (
                formBuildSubmission.occupancy &&
                formBuildSubmission.occupancyDescription === 'Unknown'
              ) {
                formBuildSubmission.occupancyDescription = ''
              }

              const insuredDetails = {}
              if (formBuildSubmission.additionalInsuredArray) {
                formBuildSubmission.additionalInsuredArray.forEach((ins) => {
                  Object.assign(insuredDetails, { ...ins })
                })
              }

              formBuildSubmission = { ...formBuildSubmission, ...insuredDetails }

              setState((prev) => ({ ...prev, submission: formBuildSubmission }))
            }
          })
          .catch((error) => {
            if (error.status === 401) {
              setState((prev) => ({ ...prev, isAuthorized: false }))
            }
          })
      }
    }, [submissionId, user])

    if (!state.isAuthorized) {
      return <NotHaveAccess />
    }

    if ((isEmpty(reduxSubmission) || !reduxSubmission) && !!state.submission) {
      return <WrappedComponent {...props} submission={state.submission} />
    }

    if (!isEmpty(reduxSubmission) || !submissionId) {
      const submissionFormData = { ...reduxSubmission }

      if (!isEmpty(submissionFormData) && isEmpty(submissionFormData.contactInfo)) {
        submissionFormData.contactInfo = {
          email: user.email,
          phone: user.phone,
        }
      }
      return <WrappedComponent {...props} submission={submissionFormData} />
    }

    return null
  }
}

export default withSubmission
